import { render } from "./mobile_nav.vue?vue&type=template&id=06094f09"
import script from "./mobile_nav.js?vue&type=script&lang=js"
export * from "./mobile_nav.js?vue&type=script&lang=js"

import "./mobile_nav.vue?vue&type=style&index=0&id=06094f09&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__